import { FormGroup } from '@angular/forms';
import { IGenericBaryFormGroup } from './GenericBaryFormGroup';
import { CompanyControls } from './builder/CompanyFormBuilder';
import { BaryFormControls } from './builder/BaryFormBuilder';
import { AssociationControls } from './builder/AssociationFormBuilder';
import { BaryUserControls, RestrictedBaryUserControls } from './builder/BaryUserFormBuilder';
import { AddressFormGroup } from './AddressFormGroup';
import { FormGroupHelper } from './FormGroupHelper';
import { BillAddressFormGroup } from './BillAddressFormGroup';
import { User } from '../user.model';
import { UserMapper } from '../../app/shared/mapper/user-mapper';
import { patchObject } from '../../app/shared/util/object-util';
import { Address } from '../address.model';

export interface IUserFormGroup<CtrlType> extends IGenericBaryFormGroup<CtrlType> {
  updateForm(model: User): void;

  updateModel(model: User): void;

  addressForm?: AddressFormGroup;
  billAddressForm?: BillAddressFormGroup;
  userForm?: IGenericBaryFormGroup<BaryUserControls | RestrictedBaryUserControls>;
  associationForm?: IGenericBaryFormGroup<AssociationControls>;
  companyForm?: IGenericBaryFormGroup<CompanyControls>;
}

export class UserFormGroup extends FormGroupHelper implements IUserFormGroup<BaryFormControls> {
  protected declare form: FormGroup;
  updated = false;
  controls: BaryFormControls;
  name: string;

  constructor(name: string, controls: BaryFormControls, asyncValidators: any = {}) {
    super();
    this.form = new FormGroup({}, asyncValidators);
    Object.keys(controls).forEach((key: string) => {
      const property = controls[key];
      if (property) {
        this.form.addControl(property.name, property.getAngularForm());
      }
    });
    this.controls = controls;
    this.name = name;
  }

  get addressForm(): AddressFormGroup | undefined {
    return this.controls.addressForm;
  }

  get billAddressForm(): BillAddressFormGroup | undefined {
    return this.controls.billAddressForm;
  }

  get userForm(): IGenericBaryFormGroup<BaryUserControls | RestrictedBaryUserControls> | undefined {
    return this.controls.userForm;
  }

  get companyForm(): IGenericBaryFormGroup<CompanyControls> | undefined {
    return this.controls.companyForm;
  }

  get associationForm(): IGenericBaryFormGroup<AssociationControls> | undefined {
    return this.controls.associationForm;
  }

  updateForm(user: User): void {
    this.controls.addressForm?.updateForm(user.address);
    this.controls.billAddressForm?.updateForm(user.billAddress);
    this.controls.billAddressForm?.controls.billEmail.setValue(user.billEmail);
    this.controls.userForm?.updateForm(user.serialize());
    this.controls.companyForm?.updateForm(user);
    this.controls.associationForm?.updateForm(user);
    this.updated = true;
  }

  updateModel(user: User): void {
    const extracted = UserMapper.extractFromBaryForm(this.form.value);
    patchObject(user, extracted);
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  value(): any {
    return UserMapper.extractFromBaryForm(this.form.value);
  }
}
